import { z } from 'zod';
export const zId = z.string().cuid();
export const zSlug = z.string().min(2).max(60).regex(/^[a-z0-9-]+$/, 'slug inválido');
export const zColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'color hex #rrggbb');
export const zIdioma = z.enum(['ES', 'PT_BR']);
export const zEstado = z.enum(['ACTIVO', 'INACTIVO']);
export const zFormato = z.enum(['R4_5', 'R1_1', 'R9_16']);
export const zTipoContenido = z.enum(['PROMOCION', 'NUEVO_INGRESO', 'CATALOGO', 'PERSONALIZAR_IMAGEN']);
export const zCanal = z.enum(['WHATSAPP', 'INSTAGRAM', 'FACEBOOK', 'TIKTOK']);
export const zRol = z.enum(['SUPERADMIN', 'ADMIN_EMPRESA', 'OPERADOR', 'CLIENTE_ADMIN', 'CLIENTE_VENDEDOR']);
/** RUC/NIT: solo dígitos, 10 a 13 (RUC Ecuador 13; cédula/NIT 10). */
export const zRuc = z
    .string()
    .trim()
    .regex(/^\d{10,13}$/, 'RUC inválido: solo dígitos, entre 10 y 13');
/**
 * Teléfono ecuatoriano: fijo = 9 dígitos (0 + provincia 2-7 + 7 números),
 * celular = 10 dígitos (09 + 8 números). Números de otro país: formato
 * internacional con «+» (E.164, 8 a 15 dígitos). Se admiten espacios,
 * guiones y paréntesis como separadores.
 */
export const zTelefono = z
    .string()
    .trim()
    .regex(/^\+?[\d\s()-]+$/, 'Teléfono inválido: solo dígitos, espacios, guiones y +')
    .refine((v) => {
    const digitos = v.replace(/\D/g, '');
    if (v.startsWith('+'))
        return digitos.length >= 8 && digitos.length <= 15;
    if (digitos.startsWith('09'))
        return digitos.length === 10;
    return /^0[2-7]\d{7}$/.test(digitos);
}, 'Teléfono inválido: celular 10 dígitos (09…), fijo 9 dígitos (0 + provincia), o internacional con +');
export const zEmail = z.string().trim().email('Email inválido');
/** Dinero en el borde de la API: número con 2 decimales (CLAUDE.md regla 4). */
export const zDinero = z.number().finite().nonnegative().multipleOf(0.01);
/** Paginación por cursor (SPEC §10). */
export const zPaginacion = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export function zPagina(item) {
    return z.object({
        items: z.array(item),
        siguienteCursor: z.string().nullable(),
    });
}
export const zRespuestaError = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const zOk = z.object({ ok: z.literal(true) });
//# sourceMappingURL=comunes.js.map